import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import   'rxjs/add/operator/map';
import { Observable } from 'rxjs';
import { SistemaService } from '../services/sistema/sistema.service';
import { PackageSearchResults } from '../models/search-results.model';

@Injectable({
  providedIn: 'root'
})
export class SearchResultsService {

  url:string;
  searchResults:PackageSearchResults[] = [];

  logger:boolean = false;



  constructor( private http:HttpClient,
               private _sistemaService:SistemaService ) {
    this.url = _sistemaService.url;
    this.logger = _sistemaService.logger;

  }

  logs(linea:string,txt:string,objeto:any = null):void{
    if (this.logger) {
      if (objeto != null) {
        console.log(linea,txt,objeto);
      }else {
        console.log(linea,txt);
      }
    }
  }

  /**
   * [getSearchResults description]
   * @param  idBrowse         [description]
   * @param  RegionSelected   [description]
   * @param  countrieSelected [description]
   * @param  valueMinL        [description]
   * @param  valueMaxL        [description]
   * @param  valueMinB        [description]
   * @param  valueMaxB        [description]
   * @param  themeSelected    [description]
   * @return                  [description]
   */
  getSearchResults(themeId,idBrowse,
    RegionSelected,
    countrieSelected,
    valueMinL:string,valueMaxL:string,
    valueMinB:string,valueMaxB:string,
    themeSelected,check,
    currentPage,onlyOnSpecialOffer,
    searchText,
    sortByParameter,sortOrder): Observable<PackageSearchResults[]>{
    
    let parametros = { 
      PageSize:12,
      CurrentPage:currentPage,
      LanguageID:"en",
      SortBy:sortByParameter,
      SortOrder:sortOrder
    }
    if (!onlyOnSpecialOffer) {
      parametros['OnlyOnSpecialOffer'] = onlyOnSpecialOffer;
    }
    if (searchText != "" && searchText != "0") {
      parametros['Search'] =  searchText;
    }
    if (idBrowse != 0) {
      parametros['StyleIDList'] = idBrowse+"";
    }
    if (RegionSelected != "" && RegionSelected != undefined) {
      parametros['RegionsIDList'] =  RegionSelected;
    }
    if (countrieSelected != "" && countrieSelected != undefined) {
      parametros['CountryIDList'] =  countrieSelected;
    }
    if (valueMinL != "" && valueMaxL != "" && valueMinL != "null" && valueMaxL != "null") {
      parametros['StartDate'] =  valueMinL;
      parametros['EndDate']  = valueMaxL;
    }
    if(valueMinB != "" && valueMinB != "null" && valueMaxB != "" && valueMaxB != "null" && valueMaxB != "0"){
      if (valueMinB == "1000000") {
        parametros['PriceFrom'] = 5250;
      }else {
        parametros['PriceFrom'] =  valueMinB;
      }
      parametros['PriceTo'] =  valueMaxB;
    }
    if ((themeSelected != "" && themeSelected != undefined) || themeId != "0") {
      if(themeSelected != "" && themeSelected != undefined && themeSelected != "0" && themeId != "0"){
        if (themeSelected[0] != themeId[0]) {
          themeSelected += ","+themeId;
        }
      }else if(themeId != "0"){
        themeSelected = themeId;
      }
      parametros['ThemeIDList'] =  this.removeZero(themeSelected);
    }
    if (check != "") {
      parametros['BambaRecommendedTrip'] = check;
    }

     
    return this.http.post(`${this.url}/package-search-result/`, parametros).map(this.extractPackageSearchResults);
  }

  removeZero(data:any):string{
    if (data != undefined && data != "") {
      data = data.split(",");
      let tmp:string[] = [];
      for (let i = 0; i < data.length; i++) {
        if(data[i] != "0"){
          tmp.push(data[i]);
        }
      }
      return tmp.join(",");
    }
  }

  extractPackageSearchResults(res:any) {
    this.searchResults = [];  
    localStorage.setItem("TotalNumberOfResults",(res.Pagination == undefined)?"0":res.Pagination.TotalNumberOfResults);
    if((res.Pagination != undefined)){
      localStorage.setItem("CurrentPage",res.Pagination.CurrentPage);
    }
    this.searchResults = res.PackageSearchResults;
    if (this.searchResults != undefined) {
      for(let i = 0;i < this.searchResults.length; i++) {
        for (let j = 0; j < this.searchResults[i].Galery.length; j++) {
          if(j == 0){
            this.searchResults[i].Galery[j].active = "active";
          }else{
            this.searchResults[i].Galery[j].active = "";
          }
        }
      }
    }
    
    return this.searchResults;
  }

}
